import React from "react";
import Avatar from "../../components/common/Avatar";

const PaymentTermsWorklistRow = ({
    item,
    rowIndex,
    menuRights,
    handleView,
    handleEdit,
    handleDelete,
}) => {
    const rowParity = rowIndex % 2 === 0 ? "row-even" : "row-odd";
    const canOpenView = menuRights?.canView === true;
    const canOpenEdit = menuRights?.canEdit === true;
    const isRowClickable = canOpenEdit || canOpenView;

    return (
        <div className={`card quote-project-row ${rowParity}`}>
            <div className="card-body">
                <div className="quote-project-grid">
                    <div
                        className="project-cell"
                        onClick={
                            canOpenEdit
                                ? () => handleEdit(item)
                                : canOpenView
                                    ? () => handleView(item)
                                    : undefined
                        }
                        style={{ cursor: isRowClickable ? "pointer" : "default" }}
                    >
                        <Avatar preName={item?.paymentDescription} />
                        <div className="project-copy">
                            <h4>{item?.paymentDescription}</h4>
                        </div>
                    </div>

                    <div className="credit-days-cell">{item?.creditDays}</div>

                    <div className="description-cell" title={item?.paymentTooltip}>
                        {item?.paymentTooltip}
                    </div>

                    <div>
                        <span
                            className={`payment-status-pill ${item?.isActive ? "active" : "inactive"
                                }`}
                        >
                            {item?.isActive ? "Active" : "Inactive"}
                        </span>
                    </div>

                    <div className="open-cell">
                        {(menuRights?.canView === true || menuRights?.canEdit === true || menuRights?.canDelete === true) && (
                            <div className="dropdown dropleft text-align">
                                <i
                                    className="fas fa-ellipsis-v"
                                    id={`paymentTermsDropdown-${item?.id}`}
                                    data-toggle="dropdown"
                                    aria-haspopup="false"
                                    aria-expanded="false"
                                ></i>
                                <div
                                    className="dropdown-menu p-0"
                                    aria-labelledby={`paymentTermsDropdown-${item?.id}`}
                                >
                                    <ul>
                                        {menuRights?.canEdit === true && (
                                            <li onClick={() => handleEdit(item)}>
                                                <i className="far fa-edit"></i> Edit
                                            </li>
                                        )}
                                        {menuRights?.canDelete === true && (
                                            <li onClick={() => handleDelete(item)}>
                                                <i className="far fa-trash-alt"></i> Delete
                                            </li>
                                        )}
                                        {menuRights?.canView === true && (
                                            <li onClick={() => handleView(item)}>
                                                <i className="far fa-eye"></i> View
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(PaymentTermsWorklistRow);